export const environment = {
  environmentName: 'mockProd',
  resourceServer: '/',
  production: true,
  mock: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts